/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Catalog_NoneInputs */

const cs_property_ai_catalog_none = /** @type {(inputs: Property_Ai_Catalog_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalogové PDF zatím není.`)
};

const en_property_ai_catalog_none = /** @type {(inputs: Property_Ai_Catalog_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No catalog PDF yet.`)
};

/**
* | output |
* | --- |
* | "No catalog PDF yet." |
*
* @param {Property_Ai_Catalog_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_catalog_none = /** @type {((inputs?: Property_Ai_Catalog_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Catalog_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_catalog_none(inputs)
	return cs_property_ai_catalog_none(inputs)
});